import { lazyWithRetry } from "utils";

export const Mypatients = lazyWithRetry(() => import("./containers"));